<div class="default-logo-header-container">
    <a class="btn-close" (click)="onBackClick()">
        <mat-icon fontSet="phr-iconset" class="phr-iconset-PHR-Volver"></mat-icon> 
    </a>
    <img class="cliniweb-icon" src="assets/images/cliniweb/logo-cliniweb-phr.svg" />    
</div>